module.exports = __webpack_public_path__ + "img/WiFi_Availability.56c91cb7.png";